export default __webpack_public_path__ + "static/media/secondary.c94917d9b3ec647d8e47deb83dcb4d14.svg";